import React, { useState } from "react";
import { DepositosABM } from "./Depositos/DepositosABM";
import { DepositosListado } from "./Depositos/DepositosListado";
import { type Deposito } from "@/lib/api";
import { useRegisterOpcionesAbmNav } from "./opcionesAbmBreadcrumb";

type DepositosView = "ABM" | "Listado";

export function DepositosSection() {
  const [currentView, setCurrentView] = useState<DepositosView>("Listado");
  const [selectedItem, setSelectedItem] = useState<Deposito | null>(null);

  const handleEdit = (item: Deposito) => {
    setSelectedItem(item);
    setCurrentView("ABM");
  };

  const handleBack = () => {
    setSelectedItem(null);
    setCurrentView("Listado");
  };

  const handleNew = () => {
    setSelectedItem(null);
    setCurrentView("ABM");
  };

  useRegisterOpcionesAbmNav(
    currentView === "ABM",
    selectedItem != null,
    handleBack
  );

  return (
    <div className="space-y-4">
      {currentView === "ABM" ? (
        <DepositosABM
          selectedItem={selectedItem}
          onBack={handleBack}
          onSaved={handleBack}
        />
      ) : (
        <DepositosListado onEdit={handleEdit} onNew={handleNew} />
      )}
    </div>
  );
}